import React, { Component } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import { _axios } from "../../plugins/axios";
import { URL, USER } from "../../constants/constant";
import ToasterComponent from "../common/toaster";
import Barcode from "react-barcode";
import PackageDetails from "../common/packageDetails";

class DropAllLabCollection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userdata: USER.user,
      orderStatus: null,
      orderDetails: null,
      cameraToggle: false,
      messageSnack: "",
      showSnack: false,
      testDetails: null,
      takingSampleForTestId: null,
      testDetails: [],
      confirmShow: false,
      membersDetails: this.props.location.state
        ? this.props.location.state.membersData
        : localStorage.getItem("upsellMemberDetailsConfirm")
        ? JSON.parse(localStorage.getItem("upsellMemberDetailsConfirm"))
        : [],
      upsellMemberDetailsConfirm: localStorage.getItem("upsellMemberDetailsConfirm") ? false : true,
      modalShow: false,
      selectedSample: null,
      latitude: "0.0",
      longitude: "0.0",
      localAddress: null,
      orderToBeDropped: null,
      dropDownStatus: true,
      selectedSampleCo: null,
      billingId: null,
      showPackageInfo: false,
      loadPackageDetails: false,
      bulkSelectedDropAtLabsModal: false,
      bulkSelectedDropAtLabsUpdate: [],
      dependentIdRelatedOrders: [],
      updateDependantIdFor: 0,
      selectedOrderId: 0,
      latlongEventTriggerFunction: (ev) => {
        const that = this;
        console.log("lat long received event triggered", ev.detail);

        if (ev.detail !== null && ev.detail !== undefined) {
          const latlong = ev.detail.split(",");
          console.log("lat long split in an arr ", latlong);
          if (latlong !== null && latlong !== undefined) {
            this.state.latitude = latlong[0];
            this.state.longitude = latlong[1];
            that.updateDropAtLabsOrderBulk();
          } else {
            that.showSnackbarFun("Location not received1, cannot continue", 2500);
          }
        } else {
          that.showSnackbarFun("Location not received, cannot continue", 2500);
        }
        ev.stopImmediatePropagation();
      },
    };
  }

  addEventListeners() {
    if (typeof android !== "undefined" && android !== null) {
      window.addEventListener("setLatLongFromApp", this.state.latlongEventTriggerFunction);
      console.log("addEventListeners : ", this.state.latlongEventTriggerFunction);
    }
  }

  cleanupListener() {
    if (typeof android !== "undefined" && android !== null) {
      window.removeEventListener("setLatLongFromApp", this.state.latlongEventTriggerFunction);
      console.log("cleanupListener : ", this.state.latlongEventTriggerFunction);
    }
  }

  componentDidMount() {
    this.addEventListeners();
    this.getOrderDetails();
  }

  componentWillUnmount() {
    this.cleanupListener();
  }

  showSnackbarFun(message, timeout) {
    this.setState(
      {
        messageSnacks: message,
        showSnackbar: true,
      },
      () => {
        this.toastComponent();
      }
    );
    setTimeout(() => {
      this.setState({
        messageSnacks: "",
        showSnackbar: false,
      });
    }, timeout);
  }

  showAlert(message, timeout) {
    this.setState({
      messageSnack: message,
      showSnack: true,
    });
    setTimeout(() => {
      this.setState({
        messageSnack: "",
        showSnack: false,
      });
    }, timeout);
  }

  toastComponent() {
    return (
      <ToasterComponent
        show={this.state.showSnackbar ? this.state.showSnackbar : ""}
        message={this.state.messageSnacks ? this.state.messageSnacks : ""}
      ></ToasterComponent>
    );
  }

  getOrderDetails() {
    const that = this;
    let url = URL.dev_url;
    let route = url + "getorders";
    let obj = {
      phleboId: this.state.userdata.phleboId,
    };

    if (localStorage.getItem("orderTestDetails")) {
      this.setState({
        testDetails: JSON.parse(localStorage.getItem("orderTestDetails")),
        totalSamples: JSON.parse(localStorage.getItem("orderTestDetails")).length,
      });
    }

    _axios
      .post(route, obj)
      .then(function (response) {
        if (response.data) {
          const groupedSampleTakenOrders = {};
          localStorage.setItem(
            "lab_technician_number",
            JSON.stringify(response.data.sampleTakenOrders[0].labDetails.AssignedLabtechnicianPhonenumber1)
          );
          response.data.sampleTakenOrders.forEach((order) => {
            const dependantId = order.dependantId;
            if (!groupedSampleTakenOrders[dependantId]) {
              groupedSampleTakenOrders[dependantId] = [];
            }
            groupedSampleTakenOrders[dependantId].push({...order, isSelected: true});
          });
          that.setState({
            loadPackageDetails: true,
            orderDetails: response.data,
            sampleDetails: groupedSampleTakenOrders,
          });
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  showPackageInfoModal(appointmentId, testName) {
    this.setState({
      showPackageInfo: !this.state.showPackageInfo,
      appointmentIdToGetPackageDetails: appointmentId,
      nameOfTestToGetPackageDetails: testName,
    });
  }

  formatAMPM(date) {
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? "0" + minutes : minutes;
    var strTime = hours + ":" + minutes + " " + ampm;
    return strTime;
  }

  checkSkipOtp() {
    let skip = false;
    if (skip) {
      if (sampleData !== null) {
        sampleData = sampleData.filter((i) => i.orderStatus.currentStatusId === 6);

        this.setState({
          sampleDetails: sampleData,
        });
      }
    }
  }

  markBulkDropAtLabsUpdate(dependantId, e) {
    let sampleDetails = this.state.sampleDetails;
    sampleDetails[dependantId].forEach((order) => (order.isSelected = e.target.checked));
    this.setState({
      sampleDetails: sampleDetails,
    });
    console.log(sampleDetails);
  }

  async updateDropAtLabsOrderBulk() {
    try {
      let url = URL.dev_url;
      let route = url + "bulkUpdateOrders";
      let allRequestBodies = [];
      let obj;
      for (let dependantId of Object.keys(this.state.sampleDetails)) {
        let order = this.state.sampleDetails[dependantId][0];
        if (!order.isSelected) continue;
        obj = {
          access_token: "trialTest" || USER.access_token,
          currentStatusId: 7,
          requestNextStatusId: 8,
          phleboId: this.state.userdata.phleboId,
          dependantId: dependantId,
          executeAtPatientLevel: true,
          lat: parseFloat(this.state.latitude).toFixed(4).toString(),
          long: parseFloat(this.state.longitude).toFixed(4).toString(),
        };
        allRequestBodies.push(obj);
      }
      let response = await _axios.post(route, { 
        allRequestBodies: allRequestBodies 
      });
      if (localStorage.getItem("failureLog")) {
        localStorage.removeItem("failureLog");
      }
      if (!response.data.success) {
        throw new Error("Something went wrong!!!");
      }
      this.props.history.push("/dependantOrders/completed");
    } catch (error) {
      console.log(error);
    }
  }

  showMemberDetails() {
    return (
      <div className="p-10">
        {this.state.sampleDetails
          ? Object.keys(this.state.sampleDetails).map((elem, index) => {
              const sampleTakenOrder = this.state.sampleDetails[elem][0];
              const sampleTakenOrders = this.state.sampleDetails[elem];
              return (
                <div className="p-10">
                  <div className="order-details-dashboard" key={index}>
                    <div className="header-sample">
                      <input
                        type="checkbox"
                        id={sampleTakenOrder.dependantId}
                        name={sampleTakenOrder.dependantId}
                        onChange={(e) => this.markBulkDropAtLabsUpdate(sampleTakenOrder.dependantId, e)}
                        checked={sampleTakenOrder.isSelected}
                      />
                      <Container>
                        <Row>
                          <Col xs={12} md={12} className="p-10">
                            <div className="font-size-ml bold">Sample to be Dropped at Center</div>
                          </Col>
                        </Row>
                        <Row>
                          <Col xs={12} md={12} className="p-b-10">
                            <div className="font-size-smd bold">
                              {sampleTakenOrder.labDetails.AssignedLab != null ? sampleTakenOrder.labDetails.AssignedLab : ""}
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col xs={12} md={12} className="p-b-5">
                            <div className="font-size-smd">
                              <i className="fa fa-map-marker width-5 p-l-2 p-b-10" aria-hidden="true"></i>
                              Lab Address
                            </div>
                            <div className="font-size-smd bold">
                              {sampleTakenOrder.labDetails.AssignedLabAddress != null ? sampleTakenOrder.labDetails.AssignedLabAddress : ""}
                            </div>
                          </Col>
                        </Row>
                      </Container>
                    </div>

                    <Container>
                      <Row className="m-10 sample-order-header-labs">
                        <Col xs={12} md={12}>
                          <div className="font-size-sm uppercase">Dependant ID</div>
                          <div className="font-size-smd bold">{sampleTakenOrder.dependantId}</div>
                        </Col>
                      </Row>
                      {sampleTakenOrder.spcOrderId && (
                        <div>
                          <Row className="m-10 sample-order-header-labs">
                            <Col xs={12} md={12}>
                              <div className="font-size-sm uppercase">{`Order Id of ${sampleTakenOrder.labDetails.AssignedLab}`}</div>
                              <Barcode value={sampleTakenOrder.spcOrderId} />
                            </Col>
                          </Row>
                        </div>
                      )}
                      <Row className="p-l-10 p-r-10 p-b-10">
                        <Col xs={6} md={6}>
                          <div className="font-size-smd uppercase">Name</div>
                          <div className="font-size-smd bold">{sampleTakenOrder.patientDetails[0].name}</div>
                        </Col>
                        <Col xs={6} md={6}>
                          <div className="font-size-smd">Time</div>
                          <div className="font-size-smd bold">{this.formatAMPM(new Date(sampleTakenOrder.orderDateTime))}</div>
                        </Col>
                      </Row>
                      <Row>
                        <Col xs={12} md={12}>
                          <div className="p-l-10 p-r-10 p-t-10">
                            <div className="font-size-md bold">
                              <i className="fa fa-flask width-5 p-l-2" aria-hidden="true"></i>
                              Tests
                            </div>
                            <div className="font-size-smd">
                              <ol>
                                {sampleTakenOrders
                                  ? sampleTakenOrders.map((order) => {
                                      return order.tests.map((elem) => {
                                        return (
                                          <li key={elem.testId}>
                                            {`${elem.testName} - ${order.appointmentId}`}
                                            <button
                                              className="btn btn-default"
                                              onClick={() => this.showPackageInfoModal(order.appointmentId, elem.testName)}
                                            >
                                              <svg fill="#000000" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" width="15px" height="15px">
                                                {" "}
                                                <path d="M25,2C12.297,2,2,12.297,2,25s10.297,23,23,23s23-10.297,23-23S37.703,2,25,2z M25,11c1.657,0,3,1.343,3,3s-1.343,3-3,3 s-3-1.343-3-3S23.343,11,25,11z M29,38h-2h-4h-2v-2h2V23h-2v-2h2h4v2v13h2V38z" />
                                              </svg>
                                            </button>
                                          </li>
                                        );
                                      });
                                    })
                                  : ""}
                              </ol>
                            </div>
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col xs={12} md={12}>
                          <div className="p-10">
                            <div className="font-size-smd">
                              <i className="fa fa-map-marker width-5 p-l-2 p-b-10" aria-hidden="true"></i>
                              Customer Address
                            </div>
                            <div className="font-size-smd bold p-l-15">
                              {sampleTakenOrder.patientDetails[0].addressLine1 ? (
                                <span> {sampleTakenOrder.patientDetails[0].addressLine1}, </span>
                              ) : (
                                ""
                              )}
                              {sampleTakenOrder.patientDetails[0].addressLine2 ? (
                                <span> {sampleTakenOrder.patientDetails[0].addressLine2}, </span>
                              ) : (
                                ""
                              )}
                              {sampleTakenOrder.patientDetails[0].landmark ? sampleTakenOrder.patientDetails[0].landmark : ""} -{" "}
                              {sampleTakenOrder.patientDetails[0].pincode ? sampleTakenOrder.patientDetails[0].pincode : ""}
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </Container>
                  </div>
                </div>
              );
            })
          : ""}
      </div>
    );
  }

  render() {
    return (
      <div>
        {this.showMemberDetails()}
        {this.state.showSnack ? <div className="snackbar show">{this.state.messageSnack}</div> : ""}
        {this.state.showPackageInfo && (
          <PackageDetails
            showPackageInfo={this.state.showPackageInfo}
            showPackageInfoModal={() => this.showPackageInfoModal()}
            appointmentId={this.state.appointmentIdToGetPackageDetails}
            packageName={this.state.nameOfTestToGetPackageDetails}
          />
        )}
        <Container>
          <div className="fixed-bottom p-l-15 p-r-15 p-t-5 p-b-5">
            <Row>
              <Col xs={12} md={12}>
                <div>
                  <Button variant="primary" size="md" block className="border-curve-10" onClick={() => this.updateDropAtLabsOrderBulk()}>
                    Submit Sample At Lab
                  </Button>
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    );
  }
}
export default DropAllLabCollection;
